export default __webpack_public_path__ + "static/media/img_demo_04_m.3098e16d.jpg";